module.exports = __webpack_public_path__ + "img/Recycling.c3bf28a5.svg";